"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNamedOutlet = exports.useTypedNavigate = exports.resolveRoute = exports.Routes = void 0;
const routes = __importStar(require("./modules"));
const typedRoute_1 = require("typedRoute");
exports.Routes = (0, typedRoute_1.createRoutes)(routes);
exports.resolveRoute = (0, typedRoute_1.createResolver)(routes);
exports.useTypedNavigate = (0, typedRoute_1.createNavigateHook)(routes);
exports.useNamedOutlet = (0, typedRoute_1.createNamedOutletHook)(routes);
